export default __webpack_public_path__ + "static/media/JP2-2.3f5d6eb1.jpg";